import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Card, Form, Input, Button, Space, Alert } from 'antd';
import { GlobalOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { createRemoteConfig } from '../../graphql/mutation';
import { showSnackBar } from '../../components/SnackBar/SnackBar';
import './CreateRemoteConfig.css';

const CreateRemoteConfig = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState(null);

  const [createMutation] = useMutation(createRemoteConfig);

  const handleSubmit = async (values) => {
    setFormError(null);
    setSubmitting(true);
    try {
      const result = await createMutation({
        variables: { name: values.name.trim() },
      });
      const newId = result.data?.createRemoteConfig?.id;
      if (!newId) throw new Error('Failed to create Remote Config');

      showSnackBar('success', 'Created', 'Remote Config created. Set up the content on the next page.');
      navigate(`/remote-configs/${newId}`);
    } catch (e) {
      const msg = (e.message || '').replace(/^GraphQL error: ?/i, '');
      setFormError(msg || 'Failed to create');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="create-remote-config-container">
      <Card
        title={
          <Space>
            <GlobalOutlined />
            Create Remote Config
          </Space>
        }
        extra={
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/remote-configs')}
          >
            Back to list
          </Button>
        }
      >
        <p style={{ color: 'rgba(0,0,0,0.55)', marginTop: 0 }}>
          Just pick a unique name. You'll set up the default <code>en</code> content
          and any extra locales (including AI auto-translation) on the next page.
        </p>

        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="name"
            label="Name"
            rules={[
              { required: true, message: 'Please enter a name' },
              { whitespace: true, message: 'Name cannot be blank' },
            ]}
            tooltip="The name you'll reference in RevenueCat metadata"
          >
            <Input placeholder="e.g. paywall_default" autoFocus />
          </Form.Item>

          {formError && (
            <Alert
              type="error"
              showIcon
              message={formError}
              style={{ marginBottom: 16 }}
            />
          )}

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={submitting}>
                Create & continue
              </Button>
              <Button onClick={() => navigate('/remote-configs')}>Cancel</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateRemoteConfig;
